import CreatePlotIcon from "@/assets/icons/create_plot.svg?react";
import { Button } from "antd";

type PlotPlaceholderProps = {
  readonly onCreatePlot: () => void;
};

export default function PlotPlaceholder({
  onCreatePlot,
}: PlotPlaceholderProps) {
  return (
    <div className="flex flex-col" data-testid="plot-placeholder">
      <CreatePlotIcon />
      <div className="flex flex-col text-center items-center">
        <p className="text-base font-bold">Your dashboard is currently empty</p>
        <p className="text-sm mt-2">Create your first widget to get started</p>
        <Button
          data-testid="add-new-widget-button"
          type="primary"
          className="mt-3 w-[188px]"
          onClick={onCreatePlot}
        >
          + Add new widget
        </Button>
      </div>
    </div>
  );
}
